















































































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';

import GadgetFrame, {IFrame} from './EditerGadgetFrameV3.vue';
import Charts from '@/components/charts';
import ListChart from '@/components/charts/ListChartV3.vue';
import SelectBox, {IOption} from '@/components/util/SelectBoxV3.vue';
import { ITooltip } from '@/class/models/typed/gadget/basicGadget';
import { tooltipOption } from '@/parts/graph/GraphTooltip.vue';
import { datalabelValueFormatter, datalabelNameFormatter } from '@/components/charts/Doughnut.vue';

const EDIT = 'EDIT';

// 通信
// import API from '@/api/common';
// const api = new API();
import * as models from '@/class/models/views/graph';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'SampleGadgetBaseV3',
  components: { GadgetFrame, SelectBox, ListChart },
  props: {
    title: String,
    materials: Object,
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    w: {
      type: Number,
      default: 1,
    },
    h: {
      type: Number,
      default: 1,
    },
    dashBoard: {
      type: Boolean,
      default: false,
    },
    plasticCase: {
      type: Boolean,
      default: false,
    },
    resized: {
      type: Boolean,
      default: true,
    },
    initialValue: String,
  },
  data() {
    return {
      mode: EDIT,
      charts: Charts,
      selectGraphValue: '',
      dataObj: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [40, 39, 10, 40, 39, 80, 40],
          },
        ],
      },
      // dataObj: {},
      optionsObj: {},
      baseOptionsObj: {
        responsive: !this.dashBoard,
        maintainAspectRatio: !this.dashBoard,
        tooltips: tooltipOption,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{display: false, value: {}, ticks: {}, gridLines: {}}],
          xAxes: [{display: false, value: {}, ticks: {}, gridLines: {}}],
        },
        plugins: {
          datalabels: {
            color: '#fff',
            padding: 0,
            font: { lineHeight: 0 }, // topとbottomの間を詰める
            labels: {
              name: { align: 'top', font: {lineHeight: 0.9, size: 10} },
              value: { align: 'bottom', font: {lineHeight: 1, size: 13, weight: 'bold'} },
            },
          },
        },
      },
      ct1Options: [{text: '田中', value: 1}] as IOption[],
      ct1Value: '',
      ct1Back: '[]',
      ct1ValueBack: 0,
      ct1Flag: false,
      ct2Options: [{text: '2020', value: 2020}] as IOption[],
      ct2Back: '[]',
      ct2Flag: false,
      ct2: '',
      ct2ValueBack: '',
      year: moment.fncGetThisYear(),
      month: moment.fncGetLastMonthStr(),
      date: moment.fncGetLastMonthDateStr(),
      widthX: GRAPH_HW,
      heightX: GRAPH_HW,
      error: false,
      loading: false,
      ratio: 1,
      tooltip: {} as ITooltip,
      legendList: [] as any[],
      isDisplayLegend: false,
      isMultiDoughnut: false,
    };
  },
  watch: {
    /*
    async year(newInput, oldInput) {
      if (newInput !== oldInput) {
        const material = this.materials.target.filter((v: models.ICommonObj) => (v.key === '年'));
        material[0].value = newInput;
        this.ct2ValueBack = newInput;
        // await this.getBasicGraphData();
      }
    },
    async month(newInput, oldInput) {
      if (newInput !== oldInput) {
        const material = this.materials.target.filter((v: models.ICommonObj) => (v.key === '月'));
        material[0].value = newInput;
        this.ct2ValueBack = newInput;
        // await this.getBasicGraphData();
      }
    },
    async date(newInput, oldInput) {
      if (newInput !== oldInput) {
        const material = this.materials.target.filter((v: models.ICommonObj) => (v.key === '日'));
        material[0].value = newInput;
        this.ct2ValueBack = newInput;
        // await this.getBasicGraphData();
      }
    },
    */
    w() {
      this.setSize();
    },
    h() {
      this.setSize();
    },
  },
  async mounted() {
    if (this.gadgetData) {
      this.selectGraphValue = this.gadgetData.data.graph[0].key;
      const options = this.gadgetData.options;
      if (options) {
        this.isDisplayLegend = NOC.OPTION.V2.getValues(options, NOC.OPTION.V2.KEY.LEGEND) || false;
        this.isMultiDoughnut = NOC.OPTION.V2.getValues(options, NOC.OPTION.V2.KEY.MULTI_DOUGHNUT) || false;
      }
      // サンプルデータ設定処理
      this.setSize();

      // console.log(this.gadgetData.data);

      if (this.gadgetData.data.materials.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_APP.id)) {
        this.sample5(); // アプリ（SAMPLE8）
      } else if (this.isMultiDoughnut) {
        this.sample6(); // 複数人円グラフ（SAMPLE9）
      } else {
        const measureDate = NOC.MATERIAL.V3.getTargetDate(this.gadgetData.data.materials);
        if (measureDate) {
          if (measureDate.id === NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH.id) {
            if (this.gadgetData.options && NOC.OPTION.V2.getValues(this.gadgetData.options, NOC.OPTION.V2.KEY.DATA_SERIES)) {
              this.sample7();
            } else {
              this.sample1();
            }
          } else if (measureDate.id === NOC.MATERIAL.V3.MATERIAL.TARGET_DATE.id) {
            const setDate = NOC.MATERIAL.V3.getTargetSetData(this.gadgetData.data.materials);
            if (setDate) {
              this.sample3();
            } else {
              this.sample2();
            }
          } else if (measureDate.id === NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR.id) {
            this.sample4();
          }
        }
      }
    }
    // await this.getBasicGraphData();
  },
  methods: {
    onClickZoom() {
      this.$emit('zoom');
    },
    setSize() {
      // console.log(this.w);
      this.heightX = GRAPH_HW * this.h;
      this.widthX = GRAPH_HW * this.w;
      if (this.isDisplayLegend) {
        this.heightX = this.heightX - 20;
      }
    },
    getRatio(): number {
      if (!this || !this.$refs || !this.$refs.chartdom) {
        return 1;
      }
      const mycanvas = (this.$refs.chartdom as any).$refs.canvas;
      const position = mycanvas.getBoundingClientRect();
      const styleWidth = mycanvas.style.width;
      return position.width / styleWidth.substr(0, styleWidth.length - 2);
    },
    customToolTips(tooltipModel: any) {
      // ツールチップイベント
      const canvas = (this.$refs.chartdom as any).$refs.canvas;
      const position = canvas.getBoundingClientRect();
      this.tooltip = { tooltipModel, ratio: this.ratio, position };
      this.$emit('setTooltip', this.tooltip);
    },
    changeLegend(newValue: string) {
      // 凡例表示
      this.ratio = this.getRatio();

      const datasets = this.dataObj.datasets;
      if (this.isMultiDoughnut) {
        const labels = this.dataObj.labels;
        this.legendList = labels.map((v: any, index: number) => ({ index, bgcolor: datasets[0].backgroundColor[index], value: v, hidden: false }));
      } else {
        this.legendList = datasets.map((v: any, index: number) => ({ index, bgcolor: v.backgroundColor[0], value: v.label, hidden: false }));
      }

      if (this.gadgetData.title === '【日次】実労働時間グラフ(メンバー毎)' || this.gadgetData.title === '【月次】実労働時間グラフ(メンバー毎)') {
        this.isDisplayLegend = true;
        this.legendList = datasets.map((v: any, index: number) => ({ index, bgcolor: NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], value: '実労働時間', hidden: false }));
      } else if (this.gadgetData.title === '【日次】実労働時間グラフ(全メンバー)' || this.gadgetData.title === '【年次】総実労働時間グラフ(メンバー毎)') {
        this.isDisplayLegend = true;
        this.legendList = datasets.map((v: any, index: number) => ({ index, bgcolor: '', value: '', hidden: false }));
        // this.legendList = datasets.map((v: any, index: number) => ({ index, bgcolor: NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], value: '勤務時間', hidden: false }));
      }
    },
    onClickLegend(idx: number) {
      // 凡例クリック時、該当データを非表示にする
      const chart = (this.$refs.chartdom as any).$data._chart;
      const meta = this.isMultiDoughnut ? chart.getDatasetMeta(0).data[idx] : chart.getDatasetMeta(idx);
      meta.hidden = !meta.hidden;
      chart.update();
      this.legendList[idx].hidden = !this.legendList[idx].hidden;
    },
    tooltipTitle(tooltipItem: any[], data: any): string[] { // ツールチップ先頭の太字部分
      let title = tooltipItem[0].label;
      switch (this.selectGraphValue) {
        case NOC.CHARTS.DOUGHNUT:
        case NOC.CHARTS.PIE:
        case NOC.CHARTS.RADAR:
          title = this.isMultiDoughnut ? [] : data.labels[tooltipItem[0].index];
          break;
      }
      return title;
    },
    tooltipLabel(tooltipItem: any, data: any): string {
      // ツールチップの「XXX：99.99h」部分
      let label = data.datasets[tooltipItem.datasetIndex].label;
      if (this.isMultiDoughnut) {
        label = data.labels[tooltipItem.index];
      }
      label = label ? `${label}：` : '';
      let isMembers = false;
      let value = tooltipItem.value;
      switch (this.selectGraphValue) {
        case NOC.CHARTS.PIE:
        case NOC.CHARTS.DOUGHNUT:
          value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          isMembers = this.isMultiDoughnut;
          break;
      }
      if (isMembers) {
        label = `${label}${value}名`;
      } else {
        if (this.gadgetData.data.materials.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.id)) {
          label = `${label}${value}回`;
        } else {
          label = this.gadgetData.data.materials.some((v: any) => (v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR.id))
            ? `${label}${value}m`
            : `${label}${value}h`;
        }
      }
      return label;
    },
    tooltipFooter(tooltipItem: any[], data: any): string[] { // 「XXX (99.99h)」部分
      let footer = [];
      if (this.isMultiDoughnut) {
        footer = data.datasets[tooltipItem[0].datasetIndex].tooltip[tooltipItem[0].index];
      }
      return footer;
    },
    setTooltipOption(optionsObj: any) {
      optionsObj.tooltips.custom = this.customToolTips;
      optionsObj.tooltips.callbacks.title = this.tooltipTitle;
      optionsObj.tooltips.callbacks.label = this.tooltipLabel;
      optionsObj.tooltips.callbacks.footer = this.tooltipFooter;
      optionsObj.tooltips.callbacks.labelColor = (tooltipItem: any, chart: any) => ({
        backgroundColor: chart.config.data.datasets[tooltipItem.datasetIndex].backgroundColor[tooltipItem.index],
        borderColor: '#fff',
      });
    },
    sample1() {
      this.ct2 = '月';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);
      let unit = '';
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
          case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = false;
          tmpOptionObj.scales.yAxes[0].gridLines.display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = true;
          tmpOptionObj.scales.yAxes[0].gridLines.display = false;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? `${val}h` : '';
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
      color = color.concat(color);

      labels = ['高橋', '鈴木', '佐藤', '山田', '矢口', '佐々木', '田中'];
      datasets =  [
          {
            label: '実労働時間',
            backgroundColor: color,
            data: [180, 170, 130, 80, 60, 10, 0],
          },
      ];
      switch (this.selectGraphValue) {
        case NOC.CHARTS.LINE: {
          const linebackcolor = (colors: string[]) => (colors.map((v: string) => (this.hex2rgba(v, 1))));
          for (const dataset of datasets) {
            const bgcolor = linebackcolor(dataset.backgroundColor);
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        }
        case NOC.CHARTS.LIST: {
          switch (this.gadgetData.title) {
            case '【月次】実労働時間リスト(全メンバー)':
              unit = 'h';
              labels = ['高橋', '鈴木', '佐藤', '山田', '矢口', '佐々木', '田中'];
              datasets =  [
                  {
                    label: '勤務',
                    backgroundColor: color,
                    data: [180, 170, 130, 80, 60, 10, 0],
                  },
                  {
                    label: '残業',
                    backgroundColor: color,
                    data: [3, 1, 3, 8, 6, 1, 0],
                  },
                  {
                    label: '就業未達成',
                    backgroundColor: color,
                    data: [-20, -10, -5, -2, -22, -3, -1],
                  },
              ];
              break;
            case '【月次】実労働時間リスト（メンバー毎）':
              datasets = [];
              labels = [...Array(30)].map((v, i) => ( (i + 1) + '日'));
              datasets =  [
                {
                  label: '開始時間',
                  data: ['10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00'],
                },
                {
                  label: '終了時間',
                  data: ['19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00'],
                },
                {
                  label: '実労働',
                  data: ['8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h'],
                },
              ];
              break;
            case '36協定状況リスト':
              labels = ['所定労働時間外（月）', '法定労働時間外（月）', '超過回数', '所定労働時間外（年）', '法定労働時間外（年）'];
              datasets =  [
                {
                  label: '時間/回数',
                  data: ['20時間', '18時間', '3回', '150時間', '148時間'],
                },
              ];
              break;
            case '禁止アプリ利用者リスト':
              labels = ['営業1課', '営業1課', '営業2課'];
              datasets =  [
                {
                  label: '氏名',
                  data: ['山田太郎', '加藤二郎', '田中三郎'],
                },
                {
                  label: '職種',
                  data: ['一般', '一般', '一般'],
                },
                {
                  label: 'アラート回数',
                  data: ['3', '10', '15'],
                },
                {
                  label: '禁止アプリ利用時間',
                  data: ['YouTube:10時間\nTwitter:5時間\nInstagram:1時間', 'YouTube:10時間\nTwitter:5時間\nInstagram:1時間', 'YouTube:10時間\nTwitter:5時間\nInstagram:1時間'],
                },
              ];
              break;
          }
          for (const dataset of datasets) {
            dataset.data = dataset.data.map((v: number) => `${v}${unit}`);
          }
          break;
        }
        case NOC.CHARTS.BAR: {
          // 比較グラフのタイトル格納
          const comparisonGraphTitle = ['就業時間の推移と比較（月間）', '実労働時間の推移と比較（月間）', '禁止アプリ利用時間の推移と比較（月間）'];
          const dateArray = [...Array(30)].map((v, i) => ( (i + 1) + '日'));

          // 就業時間などの最小値最大値の値を設定する変数
          let timeMax = 0;
          let timeMin = 0;

          if (comparisonGraphTitle.indexOf(this.gadgetData.title) !== -1) {

            // 平均就業時間、平均実労働時間、禁止アプリ利用時間の最大値、最小値の設定
            if (this.gadgetData.title === '禁止アプリ利用時間の推移と比較（月間）') {
              timeMin = 0, timeMax = 5;
            } else {
              timeMin = 0, timeMax = 8;
            }
            const dateArray2 = [...Array(30)].map((v, i) => ( (i + 1) + '日'));
            labels = dateArray2;

            // 2つのグラフの色の設定
            let bgColor1 = '';
            let bgColor2 = '';
            if (this.gadgetData.title === '就業時間の推移と比較（月間）') {
              bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_RED[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_RED[1];
            } else if (this.gadgetData.title === '実労働時間の推移と比較（月間）') {
              bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[1];
            } else if (this.gadgetData.title === '禁止アプリ利用時間の推移と比較（月間）') {
              bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[1];
            }

            datasets =  [
              {
                type: 'line',
                label: '山田太郎',
                backgroundColor: labels.map((_) => bgColor1),
                data: dateArray2.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              },
              {
                type: 'bar',
                label: '営業1課 平均',
                backgroundColor: labels.map((_) => bgColor2),
                data: dateArray2.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              },
            ];
            for (const dataset of datasets) {
              const bgcolor = dataset.backgroundColor;
              dataset.borderColor = bgcolor;
              dataset.pointBorderColor = bgcolor;
              dataset.pointBackgroundColor = '#fff';
              dataset.pointRadius = 4;
              dataset.fill = false;
              dataset.lineTension = 0; // 直線
            }
          }

          if (this.gadgetData.title === '【月次】実労働時間グラフ(メンバー毎)') {
            this.ct1Flag = true;
            labels = dateArray;
            timeMax = 8, timeMin = 0;
            datasets =  [
              {
                backgroundColor: labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0]),
                data: dateArray.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              },
            ];
          }
          break;
        }
      }
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample2() {
      this.ct2 = '日';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = false;
          tmpOptionObj.scales.yAxes[0].gridLines.display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = true;
          tmpOptionObj.scales.yAxes[0].gridLines.display = false;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? (v: any) => (`${v}h`) : '';
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
      color = color.concat(color);
      if (this.gadgetData.title === '【日次】実労働時間リスト(全メンバー)') {
        labels = ['高橋', '鈴木', '佐藤', '山田', '矢口', '佐々木', '田中'];
        datasets =  [
            {
              label: '勤務',
              backgroundColor: color,
              data: [8, 8, 7, 6.5, 8, 8, 10],
            },
            {
              label: '残業',
              backgroundColor: color,
              data: [2, 0, 0, 1.5, 1, 2, 0],
            },
            {
              label: '就業未達成時間',
              backgroundColor: color,
              data: [-8, -4, -7, -6.5, -8, -2, -0],
            },
        ];
      } else {
        labels = ['高橋', '鈴木', '佐藤', '山田', '矢口', '佐々木', '田中'];
        datasets =  [
            {
              label: '実労働時間',
              backgroundColor: color,
              // backgroundColor: NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0],
              data: [8, 4, 7, 6.5, 8, 2, 0],
            },
        ];
      }
      switch (this.selectGraphValue) {
        case NOC.CHARTS.LINE:
          const linebackcolor = (colors: string[]) => (colors.map((v: string) => (this.hex2rgba(v, 1))));
          for (const dataset of datasets) {
            const bgcolor = linebackcolor(dataset.backgroundColor);
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        case NOC.CHARTS.LIST:
          for (const dataset of datasets) {
            dataset.data = dataset.data.map((v: number) => `${v}h`);
          }
          break;
      }
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample3() {
      this.ct1Flag = true;
      this.ct2 = '日';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);
      let unit = 'm';
      if (this.gadgetData.title === '【日次】操作回数グラフ（メンバー毎）') {
        unit = '回';
      }
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = false;
          tmpOptionObj.scales.yAxes[0].gridLines.display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return `${(label).toString()} ${unit}`;
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = true;
          tmpOptionObj.scales.yAxes[0].gridLines.display = false;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + '分';
            },
          };
          break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? (v: any) => (`${v}m`) : '';
          };
          break;
      }

      // let color = NOC.GRAPH.OPTIONS.BCOLOR;
      // color = color.concat(color);

      // 表示範囲を10時～19時のみに変更
      const dateArray = [...Array(10)].map((_, i) => ((i + 10) + '時'));
      let dataListArray = ['高橋', '鈴木', '佐藤', '山田', '矢口'];

      labels = dateArray;
      datasets =  [
          {
            label: '実労働時間',
            backgroundColor: this.hex2rgba(NOC.GRAPH.OPTIONS.BCOLOR_BETA[0], 1),
            data: dateArray.map((_, i) => {
              if (i !== 3) {
                return Math.floor(Math.random() * Math.floor(5)) * 15;
              } else {
                return 0;
              }
            }),
          },
      ];
      switch (this.selectGraphValue) {
        case NOC.CHARTS.LINE: {
          if (this.gadgetData.title !== '【日次】実労働時間グラフ(メンバー毎)') {
            this.ct1Flag = false;

            // 操作回数を0-1000回の範囲でランダムに設定。
            // const labelList = ['高橋', '鈴木', '佐藤'];
            const labelList = ['高橋'];
            const countMin = 0;
            const countMax = 1000;
            datasets = [];
            for (let i = 0; i < labelList.length; i++) {
              datasets.push({
                label: labelList[i],
                // backgroundColor: labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BETA[i]),
                backgroundColor: labels.map((_) => '#8D46E8'),
                data: labels.map(() => {
                  return Math.floor(Math.random() * (countMax - countMin + 1)) + countMin;
                }),
              });
            }
          }
          const linebackcolor = (colors: string[]) => (colors.map((v: string) => (this.hex2rgba(v, 1))));
          for (const dataset of datasets) {
            // グラフが複数の時にradiusの色を統一かつ、グラフが単体の時にエラーが出ないように条件分岐。
            let graphColor;
            if (this.gadgetData.title === '【日次】実労働時間グラフ(メンバー毎)') {
              graphColor = dataset.backgroundColor;
            } else {
              graphColor = linebackcolor(dataset.backgroundColor);
            }
            const bgcolor = graphColor;
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        }
        case NOC.CHARTS.LIST: {
          // リストの中身の単位
          unit = '';
          this.ct1Flag = false;
          datasets = [];
          switch (this.gadgetData.title) {
            case '【日次】実労働時間リスト（全メンバー）':
              labels = dataListArray;
              unit = 'h';

              // 実労働時間は4-8h, 残業時間は0-2, 就業未達成時間は-3～0hでランダムに設定。signはプラスマイナスの符号を調整するもの
              const labelList = ['勤務', '残業', '就業未達成'];
              const timeMin = [4, 0, 0];
              const timeMax = [8, 2, 3];
              const sign = [1, 1, -1];
              for (let i = 0; i < labelList.length; i++) {
                datasets.push({
                  label: labelList[i],
                  data: dataListArray.map(() => {
                    return sign[i] * Math.floor(Math.random() * (timeMax[i] - timeMin[i] + 1)) + timeMin[i];
                  }),
                });
              }
              break;
            case '36協定違反者リスト':
              dataListArray = ['営業1課', '営業2課', '営業2課'];
              labels = dataListArray;
              datasets =  [
                {
                  label: '氏名',
                  data: ['山田太郎', '加藤二郎', '田中三郎'],
                },
                {
                  label: '職種',
                  data: ['一般', '一般', '一般'],
                },
                {
                  label: '昨日の残業',
                  data: ['5時間(所定・特別)\n5時間(法定・特別)', '5時間(所定・特別)\n5時間(法定・特別)', '5時間(所定・特別)\n5時間(法定・特別)'],
                },
                {
                  label: '今月の残業',
                  data: ['91時間(所定・特別)\n91時間(法定・特別)\n上限超過3回目', '91時間(所定・特別)\n91時間(法定・特別)', '91時間(所定・特別)\n91時間(法定・特別)'],
                },
                {
                  label: '今年の残業',
                  data: ['721時間(所定・特別)\n721時間(法定・特別)', '721時間(所定・特別)\n721時間(法定・特別)', '721時間(所定・特別)\n721時間(法定・特別)'],
                },
              ];
              break;
          }
          for (const dataset of datasets) {
            dataset.data = dataset.data.map((v: number) => `${v}${unit}`);
          }
          break;
        }
        case NOC.CHARTS.BAR: {
          this.ct1Flag = false;

          // 平均就業時間、平均実労働時間、禁止アプリ利用時間の最大値、最小値の設定
          let timeMax = 0;
          let timeMin = 0;
          if (this.gadgetData.title === '禁止アプリ利用時間の推移と比較（日）') {
            timeMin = 0, timeMax = 20;
          } else {
            timeMin = 0, timeMax = 60;
          }

          // 2つのグラフの色の設定
          let bgColor1 = '';
          let bgColor2 = '';
          if (this.gadgetData.title === '就業時間の推移と比較（日）') {
            bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_RED[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_RED[1];
          } else if (this.gadgetData.title === '実労働時間の推移と比較（日）') {
            bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[1];
          } else if (this.gadgetData.title === '禁止アプリ利用時間の推移と比較（日）') {
            bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[1];
          }

          datasets =  [
            {
              type: 'line',
              label: '山田太郎',
              backgroundColor: labels.map((_) => bgColor1),
              data: dateArray.map(() => {
                return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
              }),
            },
            {
              type: 'bar',
              label: '営業1課 平均',
              backgroundColor: labels.map((_) => bgColor2),
              data: dateArray.map(() => {
                return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
              }),
            },
          ];
          for (const dataset of datasets) {
            const bgcolor = dataset.backgroundColor;
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        }
      }
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample4() {
      this.ct1Flag = true;
      this.ct2 = '年';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = false;
          tmpOptionObj.scales.yAxes[0].gridLines.display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = true;
          tmpOptionObj.scales.yAxes[0].gridLines.display = false;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? (v: any) => (`${v}h`) : '';
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
      color = color.concat(color);
      color = color.concat(color);
      // let color = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0];
      const dateArray = [...Array(12)].map((v, i) => ( (i + 1) + '月'));

      labels = dateArray;
      datasets =  [
          {
            label: '',
            backgroundColor: color,
            data: dateArray.map((v, i) => {
              return Math.floor(Math.random() * Math.floor(30)) * 8;
            }),
          },
      ];

      let labelList;
      // 2つのグラフの色の設定
      let bgColor1 = '';
      let bgColor2 = '';
      switch (this.gadgetData.title) {
        case '部署ごとの平均就業時間の推移（年間）':
        case '就業時間の推移と比較（年間）':
          bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_RED[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_RED[1];
          break;
        case '部署ごとの平均実労働時間の推移（年間）':
        case '実労働時間の推移と比較（年間）':
          bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[1];
          break;
        case '部署ごとの禁止アプリ利用時間の推移（年間）':
        case '禁止アプリ利用時間の推移と比較（年間）':
          bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[1];
          break;
      }

      switch (this.selectGraphValue) {
        case NOC.CHARTS.LINE: {
          this.ct1Flag = false;

          // 平均就業時間、平均実労働時間、禁止アプリ利用時間の最大値、最小値の設定
          let timeMax = 0;
          let timeMin = 0;
          if (this.gadgetData.title === '部署ごとの禁止アプリ利用時間の推移（年間）' || this.gadgetData.title === 'ユーザーごとの禁止アプリ利用時間の推移（年間）') {
            timeMin = 0, timeMax = 10;
          } else {
            timeMin = 40, timeMax = 160;
          }

          // // 2つのグラフの色の設定
          // let bgColor1 = '', bgColor2 = '';
          // if (this.gadgetData.title === '部署ごとの平均就業時間の推移（年間）') {
          //   bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_RED[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_RED[1];
          // } else if (this.gadgetData.title === '部署ごとの平均実労働時間の推移（年間）') {
          //   bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[1];
          // } else if (this.gadgetData.title === '部署ごとの禁止アプリ利用時間の推移（年間）') {
          //   bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[1];
          // }
          if (this.gadgetData.title === 'ユーザーごとの就業時間の推移（年間）' || this.gadgetData.title === 'ユーザーごとの実労働時間の推移（年間）' || this.gadgetData.title === 'ユーザーごとの禁止アプリ利用時間の推移（年間）') {
            let mycolor = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
            mycolor = mycolor.concat(mycolor);

            labelList = ['高橋', '鈴木', '佐藤'];
            datasets = [];

            for (let i = 0; i < labelList.length; i++) {
              datasets.push({
                label: labelList[i],
                backgroundColor: dateArray.map((_) => mycolor[i]),
                data: dateArray.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              });
            }
          } else {
            datasets = [];
            labelList = ['営業1課', '営業2課'];
            const colorList = [bgColor1, bgColor2];

            // 平均就業時間、平均実労働時間、禁止アプリ利用時間それぞれを最大値、最小値の範囲でランダムに生成
            for (let i = 0; i < labelList.length; i++) {
              datasets.push({
                label: labelList[i],
                backgroundColor: labels.map((_) => colorList[i]),
                data: dateArray.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              });
            }
          }

          const linebackcolor = (colors: string[]) => (colors.map((v: string) => (this.hex2rgba(v, 1))));
          for (const dataset of datasets) {
            const bgcolor = linebackcolor(dataset.backgroundColor);
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        }
        case NOC.CHARTS.LIST: {
          datasets = [];
          labelList = ['実労働時間', '残業時間'];
          const timeMaxList = [160, 10];
          const timeMinList = [20, 0];

          // 実労働時間を20-160h,残業時間を0-10hの範囲でランダムに生成
          for (let i = 0; i < labelList.length; i++) {
            datasets.push({
              label: labelList[i],
              data: dateArray.map(() => {
                return Math.floor(Math.random() * (timeMaxList[i] - timeMinList[i] + 1)) + timeMinList[i];
              }),
            });
          }
          for (const dataset of datasets) {
            dataset.data = dataset.data.map((v: number) => `${v}h`);
          }
          break;
        }
        case NOC.CHARTS.BAR: {
          if (this.gadgetData.title !== '【年次】総実労働時間グラフ(メンバー毎)') {
            this.ct1Flag = false;

            // 平均就業時間、平均実労働時間、禁止アプリ利用時間の最大値、最小値の設定
            let timeMax = 0;
            let timeMin = 0;
            if (this.gadgetData.title === '禁止アプリ利用時間の推移と比較（年間）') {
              timeMin = 0, timeMax = 10;
            } else {
              timeMin = 40, timeMax = 160;
            }

            // // 2つのグラフの色の設定
            // let bgColor1 = '', bgColor2 = '';
            // if (this.gadgetData.title === '就業時間の推移と比較（年間）') {
            //   bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_RED[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_RED[1];
            // } else if (this.gadgetData.title === '実労働時間の推移と比較（年間）') {
            //   bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_BLUE[1];
            // } else if (this.gadgetData.title === '禁止アプリ利用時間の推移と比較（年間）') {
            //   bgColor1 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[0], bgColor2 = NOC.GRAPH.OPTIONS.BCOLOR_GREEN[1];
            // }

            datasets =  [
              {
                type: 'line',
                label: '山田太郎',
                backgroundColor: labels.map((_) => bgColor1),
                data: dateArray.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              },
              {
                type: 'bar',
                label: '営業1課 平均',
                backgroundColor: labels.map((_) => bgColor2),
                data: dateArray.map(() => {
                  return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
                }),
              },
            ];
          }
          for (const dataset of datasets) {
            const bgcolor = dataset.backgroundColor;
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        }
      }
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample5() { // アプリ
      this.ct1Flag = true;
      this.ct2 = '日';
      this.ct2Flag = true;
      const datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);
      switch (this.selectGraphValue) {
        case NOC.CHARTS.STACKED_BAR:
          tmpOptionObj.scales.xAxes[0].stacked = true;
          tmpOptionObj.scales.yAxes[0].stacked = true;
        case NOC.CHARTS.BAR:
        case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = false;
          tmpOptionObj.scales.yAxes[0].gridLines.display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'm';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = true;
          tmpOptionObj.scales.yAxes[0].gridLines.display = false;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'm';
            },
          };
          break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? (v: any) => (`${v}m`) : '';
          };
          break;
      }

      // 横軸を格納する配列, データの個数(1年のグラフなら12ヶ月分12個), 横軸の単位, 縦軸の単位, アプリ使用時間の最小値, アプリ使用時間の最大値, 横軸の数字を揃えるための変数
      let dateArray;
      let dateNum = 0;
      let horizonUnit = '';
      let verticalUnit = 'm';
      let timeMin = 0;
      let timeMax = 0;
      let adjustNum = 0;
      switch (this.gadgetData.title) {
        case '各アプリ利用時間の推移（年間)':
          dateNum = 12, timeMax = 40, timeMin = 10, horizonUnit = '月', verticalUnit = 'h';
          this.ct2 = '年';
          break;
        case '各アプリ利用時間の推移（月間)':
          dateNum = 30, timeMax = 2, horizonUnit = '日', verticalUnit = 'h';
          this.ct2 = '月';
          break;
        case '【日次】アプリ使用時間グラフ(メンバー毎)':
          dateNum = 10, timeMax = 15, horizonUnit = '時', adjustNum = 8;
          break;
      }
      dateArray = [...Array(dateNum)].map((_, i) => ((i + 1 + adjustNum) + horizonUnit));
      tmpOptionObj.scales.yAxes[0].ticks = {
        callback(label: any, index: any, ylabels: any[]) {
          return (label).toString() + verticalUnit;
        },
      };

      labels = dateArray;
      // アプリ使用時間をランダムに生成
      const hourDataList = [];
      for (let i = 0; i < 4; i++) {
        const hourData = dateArray.map(() => {
          return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
        });
        hourDataList.push(hourData);
      }

      let bgcolor = this.hex2rgba(NOC.GRAPH.OPTIONS.BCOLOR_BETA[0], 1);
      datasets.push({
        label: 'Word',
        backgroundColor: dateArray.map((_) => bgcolor),
        // data: [24.8, 31.2, 43.3, 0, 28.6, 0, 15.3, 0, 0, 0],
        data: hourDataList[0],
      });
      bgcolor = this.hex2rgba(NOC.GRAPH.OPTIONS.BCOLOR_BETA[1], 1);
      datasets.push({
        label: 'Excel',
        backgroundColor: dateArray.map((_) => bgcolor),
        // data: [0, 0, 0, 0, 11.9, 60, 43.1, 0, 0, 0],
        data: hourDataList[1],
      });
      bgcolor = this.hex2rgba(NOC.GRAPH.OPTIONS.BCOLOR_BETA[2], 1);
      datasets.push({
        label: 'メール',
        backgroundColor: dateArray.map((_) => bgcolor),
        // data: [35.15, 23.42, 10.23, 3.2, 17.31, 0, 0, 0, 0, 26.82],
        data: hourDataList[2],
      });
      bgcolor = this.hex2rgba(NOC.GRAPH.OPTIONS.BCOLOR_BETA[3], 1);
      datasets.push({
        label: 'Zoom',
        backgroundColor: dateArray.map((_) => bgcolor),
        // data: [0, 0, 0, 0, 0, 0, 0, 45, 45, 15.2],
        data: hourDataList[3],
      });
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample6() {
      this.ct2 = '月';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);

      // グラフタイトルによって単位を分ける
      let unit = '';
      if (this.gadgetData.title === '指定月のユーザーごとの残業時間') {
        unit = 'h';
      } else {
        unit = '名';
      }
      switch (this.selectGraphValue) {
        // case NOC.CHARTS.BAR:
        // case NOC.CHARTS.LINE:
        //   tmpOptionObj.scales.yAxes[0].display = true;
        //   tmpOptionObj.scales.xAxes[0].display = true;
        //   tmpOptionObj.scales.xAxes[0].gridLines.display = false;
        //   tmpOptionObj.scales.yAxes[0].gridLines.display = true;
        //   tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
        //   tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
        //   tmpOptionObj.scales.yAxes[0].ticks = {
        //     callback(label: any, index: any, ylabels: any[]) {
        //       return (label).toString() + 'h';
        //     },
        //   };
        //   break;
        // case NOC.CHARTS.HORIZONTALBAR:
        //   tmpOptionObj.scales.yAxes[0].display = true;
        //   tmpOptionObj.scales.xAxes[0].display = true;
        //   tmpOptionObj.scales.xAxes[0].gridLines.display = true;
        //   tmpOptionObj.scales.yAxes[0].gridLines.display = false;
        //   tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
        //   tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
        //   tmpOptionObj.scales.xAxes[0].ticks = {
        //     callback(label: any, index: any, xlabels: any[]) {
        //       return (label).toString() + 'h';
        //     },
        //   };
        //   break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? `${val}${unit}` : '';
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
      color = color.concat(color);

      labels = ['130h', '140h', '150h', '160h', '170h'];
      datasets =  [
          {
            label: '実労働時間',
            backgroundColor: color,
            data: [1, 2, 4, 3, 2],
            tooltip: [
              ['高橋 (135h)'],
              ['鈴木 (146h)', '佐藤 (148h)'],
              ['山田 (152h)', '矢口 (153h)', '佐々木 (157h)', '田中 (159h)'],
              ['工藤 (160h)', '伊藤 (165h)', '加藤 (166h)'],
              ['江崎 (173h)', '尾崎 (178h)'],
            ],
          },
      ];
      if (this.gadgetData.title === '指定月のユーザーごとの残業時間') {
        labels = ['高橋', '鈴木', '佐藤', '山田', '矢口'];
        datasets[0].data = [180, 170, 130, 80, 60];
      }
      // switch (this.selectGraphValue) {
      //   case NOC.CHARTS.LINE:
      //     const linebackcolor = (colors: string[]) => (colors.map((v: string) => (this.hex2rgba(v, 1))));
      //     for (const dataset of datasets) {
      //       const bgcolor = linebackcolor(dataset.backgroundColor);
      //       dataset.borderColor = bgcolor;
      //       dataset.pointBorderColor = bgcolor;
      //       dataset.pointBackgroundColor = '#fff';
      //       dataset.pointRadius = 4;
      //       dataset.fill = false;
      //       dataset.lineTension = 0; // 直線
      //     }
      //     break;
      //   case NOC.CHARTS.LIST:
      //     for (const dataset of datasets) {
      //       dataset.data = dataset.data.map((v: number) => `${v}h`);
      //     }
      //     break;
      // }
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample7() {
      this.ct2 = '月';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      this.setTooltipOption(tmpOptionObj);
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
        case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = false;
          tmpOptionObj.scales.yAxes[0].gridLines.display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + '回';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].gridLines.display = true;
          tmpOptionObj.scales.yAxes[0].gridLines.display = false;
          tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
          tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + '回';
            },
          };
          break;
        case NOC.CHARTS.DOUGHNUT:
          tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
          tmpOptionObj.plugins.datalabels.labels.value.formatter = (value: any, context: any) => {
            const val = datalabelValueFormatter(value, context);
            return val ? `${val}回` : '';
          };
          break;
      }

      if (this.gadgetData.title === 'ユーザーごとの就業時間の推移（月間）' || this.gadgetData.title === 'ユーザーごとの実労働時間の推移（月間）' || this.gadgetData.title === 'ユーザーごとの禁止アプリ利用時間の推移（月間）' ) {
        tmpOptionObj.scales.yAxes[0].ticks = {
          callback(label: any, index: any, ylabels: any[]) {
            return (label).toString() + 'h';
          },
        };

        const dateArray = [...Array(31)].map((v, i) => ( (i + 1) + '日'));
        labels = dateArray;
        let color = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
        color = color.concat(color);
        let timeMax = 0;
        let timeMin = 0;
        if (this.gadgetData.title === 'ユーザーごとの禁止アプリ利用時間の推移（月間）') {
          timeMin = 0, timeMax = 5;
        } else {
          timeMin = 7, timeMax = 15;
        }
        const labelList = ['高橋', '鈴木', '佐藤'];

        for (let i = 0; i < labelList.length; i++) {
          datasets.push({
            label: labelList[i],
            backgroundColor: dateArray.map((_) => color[i]),
            data: dateArray.map(() => {
              return Math.floor(Math.random() * (timeMax - timeMin + 1)) + timeMin;
            }),
          });
        }
      } else {
        let color = NOC.GRAPH.OPTIONS.BCOLOR_BETA;
        color = color.concat(color);

        labels = ['1日', '2日', '3日', '4日', '5日', '6日', '7日', '8日', '9日', '10日', '11日', '12日', '13日', '14日', '15日', '16日', '17日', '18日', '19日', '20日', '21日', '22日', '23日', '24日', '25日', '26日', '27日', '28日', '29日', '30日'];
        datasets =  [
            {
              label: '高橋',
              backgroundColor: labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BETA[0]),
              data: ['50876', '69928', '64719', '56410', '80873', '43327', '48635', '60808', '59238', '53552', '46226', '50945', '60159', '0', '53355', '49344', '63795', '59779', '48406', '62105', '0', '46147', '49675', '44215', '41984', '54807', '0', '0', '61389', '46726'],
            },
            {
              label: '鈴木',
              backgroundColor: labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BETA[1]),
              data: ['32468', '20514', '16404', '13671', '42251', '0', '0', '46884', '37745', '74401', '62927', '26176', '0', '0', '43055', '61043', '23219', '40911', '21750', '0', '0', '20462', '42507', '25330', '31359', '49951', '0', '0', '17589', '36111'],
            },
            {
              label: '佐藤',
              backgroundColor: labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BETA[2]),
              data: ['19844', '33311', '15620', '13840', '51139', '0', '0', '51307', '22624', '31291', '28314', '18333', '0', '0', '42029', '48990', '30683', '53061', '46842', '0', '0', '14269', '39387', '55249', '31577', '21248', '0', '0', '20755', '10783'],
            },
          ];
        }
      switch (this.selectGraphValue) {
        case NOC.CHARTS.LINE:
          // 推移グラフのタイトルを格納する配列
          const transitionGraphTitle = ['部署ごとの平均就業時間の推移（月間）', '部署ごとの平均実労働時間の推移（月間）', '部署ごとの禁止アプリ利用時間の推移（月間）'];
          if (transitionGraphTitle.indexOf(this.gadgetData.title) !== -1) {
            datasets.pop();
            datasets[0].label = '営業1課';
            datasets[1].label = '営業2課';
            tmpOptionObj.scales.yAxes[0].ticks = {
              callback(label: any, index: any, ylabel: any[]) {
                return (label).toString() + 'h';
              },
            };
          }

          switch (this.gadgetData.title) {
            case '部署ごとの平均就業時間の推移（月間）':
              datasets[0].data = [9, 9, 9, 12, 10, 0, 0, 9, 9, 9, 12, 10, 0, 0, 10, 9, 9, 12, 10, 0, 0, 8, 9, 9, 12, 10, 0, 0, 11, 9];
              datasets[1].data = [12, 10, 9, 11, 11, 0, 0, 12, 10, 9, 11, 11, 0, 0, 12, 10, 9, 11, 11, 0, 0, 12, 10, 9, 11, 11, 0, 0, 12, 10];
              datasets[0].backgroundColor = labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_RED[0]);
              datasets[1].backgroundColor = labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_RED[1]);
              break;
            case '部署ごとの平均実労働時間の推移（月間）':
              datasets[0].data = [9, 8, 10, 9, 10, 0, 0, 9, 8, 10, 9, 10, 0, 0, 9, 8, 10, 9, 10, 0, 0, 9, 8, 10, 9, 10, 0, 0, 9, 8];
              datasets[1].data = [10, 9, 9, 11, 9, 0, 0, 10, 9, 9, 11, 9, 0, 0, 10, 9, 9, 11, 9, 0, 0, 10, 9, 9, 11, 9, 0, 0, 10, 9];
              datasets[0].backgroundColor = labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BLUE[0]);
              datasets[1].backgroundColor = labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_BLUE[1]);
              break;
            case '部署ごとの禁止アプリ利用時間の推移（月間）':
              datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 1.0, 0, 0, 0, 0, 0.2, 0, 0, 0, 0.4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              datasets[0].backgroundColor = labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_GREEN[0]);
              datasets[1].backgroundColor = labels.map((_) => NOC.GRAPH.OPTIONS.BCOLOR_GREEN[1]);
              break;
          }
          const linebackcolor = (colors: string[]) => (colors.map((v: string) => (this.hex2rgba(v, 1))));
          for (const dataset of datasets) {
            const bgcolor = linebackcolor(dataset.backgroundColor);
            dataset.borderColor = bgcolor;
            dataset.pointBorderColor = bgcolor;
            dataset.pointBackgroundColor = '#fff';
            dataset.pointRadius = 4;
            dataset.fill = false;
            dataset.lineTension = 0; // 直線
          }
          break;
        case NOC.CHARTS.LIST:
          // 1日ごとの開始時間、終了時間、実労働時間のリスト用に値変更
          this.ct1Flag = true;
          datasets[0].label = '開始時間';
          datasets[1].label = '終了時間';
          datasets[2].label = '実労働';
          datasets[0].data = ['10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00', '14:00:00', '-', '09:15:00', '09:45:00', '09:15:00', '10:00:00', '10:00:00'];
          datasets[1].data = ['19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00', '14:15:00', '-', '19:00:00', '20:45:00', '19:00:00', '19:00:00', '18:30:00'];
          datasets[2].data = ['8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h', '-', '-', '8.25h', '2.5h', '5.75h', '8.25h', '6.5h'];

          for (const dataset of datasets) {
            dataset.data = dataset.data.map((v: number) => `${v}`);
          }
          break;
      }
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    hex2rgba(hex: string, alpha = 1) {
      // ロングバージョンの場合（例：#FF0000）
      let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
      let c = null;
      if (r) {
          c = r.slice(1, 4).map((x) => (parseInt(x, 16)));
      }
      // ショートバージョンの場合（例：#F00）
      r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
      if (r) {
          c = r.slice(1, 4).map((x) => (0x11 * parseInt(x, 16)));
      }
      // 該当しない場合は、nullを返す.
      if (!c) {
          return null;
      }
      return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${alpha})`;
    },
    onMouseMoveGraphParent(event: any) {
      // ダッシュボードのちらつき対策：
      // ツールチップを出している間はイベントをグリッドに伝えない
      // ドラッグアンドドロップなら伝える
      if (event.buttons < 1 && this.tooltip.tooltipModel && this.tooltip.tooltipModel.opacity > 0) {
        event.stopImmediatePropagation();
      }
    },
  },
});
